"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// A whitelist of imports from AWS SDK.
// It is important to only import the items we need from the SDK. If we wildcard, we will end up
// with build issues due to maxing out the Javascript heap.
const sns_1 = __importDefault(require("aws-sdk/clients/sns"));
exports.SNS = sns_1.default;
//# sourceMappingURL=aws-types.js.map